// extracted by mini-css-extract-plugin
module.exports = {"body":"JxEhOQtlDySDm22V5OlEt"};